import { Yield } from '@case-app/angular-library'

export const corporateGroupYields: Yield[] = [
  {
    label: 'Nom',
    property: 'name',
  },
]
